import React, { useEffect, useState, useContext, useMemo } from "react";
import { useForm } from "react-hook-form";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid2";
import TextInput from "../../components/TextInput/TextInput";
import Chip from "@mui/material/Chip";
import Collapse from "@mui/material/Collapse";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import CorporateMemberController from "./Controller/corporate_membership_controller.ts";
import InvoiceController from "./Controller/invoice_controller.ts";
import MemberUserController from "./Controller/member_user_controller.ts";
import { notification } from "antd";
import { useSearchParams } from "react-router-dom";
import { HolderOutlined } from "@ant-design/icons";
import { DndContext } from "@dnd-kit/core";
import { restrictToVerticalAxis } from "@dnd-kit/modifiers";
import {
  arrayMove,
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Button as Buttons, Table } from "antd";
import { Tag, Typography as Typographys } from "antd";
import TableContainer from "@mui/material/TableContainer";
import TableMUI from "@mui/material/Table";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import Paper from "@mui/material/Paper";
import IndividualMembershipController from "./Controller/individual_membership_controller.ts";
import { pdf } from "@react-pdf/renderer";
import MembershipFormPDF from "./pdf/application-form-pdf.tsx";


const { Text } = Typographys;

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const ExpandMore = styled((props) => {
  const { expand, ...other } = props;
  return <div {...other} />;
})(({ theme }) => ({
  marginLeft: "auto",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest,
  }),
  variants: [
    {
      props: ({ expand }) => !expand,
      style: {
        transform: "rotate(0deg)",
      },
    },
    {
      props: ({ expand }) => !!expand,
      style: {
        transform: "rotate(180deg)",
      },
    },
  ],
}));

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const Dashboard = () => {
  // expand button
  const [expanded, setExpanded] = React.useState(false);
  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  // tabs handle change
  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  // notification
  const [api, contextHolder] = notification.useNotification();
  const openNotificationWithIcon = (type, desc, msg) => {
    api[type]({
      message: msg,
      description: desc,
    });
  };

  const [shouldRefetchData, setShouldRefetchData] = useState(false);
  const [data, setData] = useState([]); //payment is default during registration eg: registration fee & first year annual subscription fee
  const [dataMemberUser, setDataMemberUser] = useState([]); //get the information of representatives accounts
  const [dataEventInvoice, setDataEventInvoice] = useState([]); //event joined invoices
  const [subRowsMP, setSubRowsMP] = useState([]);
  const [searchParams] = useSearchParams();
  const membership_registrationID = searchParams.get(
    "membership_registrationID"
  );
  const [dataSourceMP, setDataSourceMP] = React.useState([]);
  const [dataSourceEP, setDataSourceEP] = React.useState([]);
  const [dataSourceMember, setDataSourceMember] = React.useState([]);
  const [memberID, setMemberID] = React.useState();
  const [paymentID, setPaymentID] = React.useState();

  useEffect(() => {
    if (membership_registrationID) {
      const payload = new FormData();
      payload.append("membership_registrationID", membership_registrationID);

      IndividualMembershipController.getInfo(payload)
        .then((response) => {
          console.log(response);
          //   const mappedData = {
          //     name: response.name ? response.name : response.individual_name,
          //     nric: response.nric ? response.nric : response.individual_nric,
          //     member_type_label: response.member_type_label,
          //     date_of_birth: response.date_of_birth
          //       ? response.date_of_birth
          //       : response.individual_dob,
          //     correspondence_address: response.correspondence_address
          //       ? response.correspondence_address
          //       : response.individual_correspondence_address,
          //     registered_address: response.registered_address
          //       ? response.registered_address
          //       : response.individual_registered_address,
          //     office_tel_no: response.office_tel_no
          //       ? response.office_tel_no
          //       : response.individual_office_tel_no,
          //     office_address: response.office_address
          //       ? response.office_address
          //       : response.individual_office_address,
          //     email: response.email ? response.email : response.individual_email,
          //     academic_qualification_label: response.academic_qualification_label,
          //     handphone_no: response.handphone_no
          //       ? response.handphone_no
          //       : response.individual_hp_no,
          //     designation: response.designation
          //       ? response.designation
          //       : response.individual_designation,
          //     nature_of_work: response.nature_of_work
          //       ? response.nature_of_work
          //       : response.individual_nature_of_work,
          //     years_with_company: response.years_with_company
          //       ? response.years_with_company
          //       : response.individual_no_of_years_with_present_employer,
          //     committee_type_label: response.committee_type_label,
          //   };
          setData(response);
          setMemberID(response.memberID);
          setPaymentID(response.paymentID);
          const payload1 = { memberID: response.memberID };
          CorporateMemberController.getContractPaymentInfo(payload1)
            .then((response) => {
              const rowPayment = response.map((item, index) => {
                return {
                  key: index,
                  paymentID: item.paymentID,
                  payment_status: item.payment_status,
                  invoice_no: item.invoice_no,
                };
              });

              setDataSourceMP(rowPayment);

              // Collect payment items with paymentID and flatten the array
              //   const paymentItems = response.flatMap((element) =>
              //     element.payment_items.map((item) => ({
              //       ...item, // Spread payment item properties
              //       paymentID: element.paymentID, // Include paymentID
              //     }))
              //   );

              //   setSubRowsMP(paymentItems); // Update state
            })
            .catch((error) => {
              console.error("Error fetching data:", error);
            });

          MemberUserController.getMemberUser(payload1).then((response) => {
            setDataMemberUser(response);

            const dataSourceMember = response.map((item, index) => {
              return {
                key: index,
                name: item.name,
                nric: item.nric,
                email: item.email,
                address: item.address,
              };
            });
            setDataSourceMember(dataSourceMember);
          });
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    }

    InvoiceController.getEventInvoice().then((response) => {
      setDataEventInvoice(response);
    });
  }, [membership_registrationID, data.memberID, shouldRefetchData]);

  useEffect(() => {
    const userIDs = dataMemberUser.map((item, index) => item.userID);
    const events_data = dataEventInvoice
      ? dataEventInvoice
          .filter((event) => {
            return event.beneficiary.some((item) =>
              userIDs.includes(item.userID)
            );
          })
          .map((event, index) => {
            // Customize the returned data structure

            return {
              key: index,
              paymentID: event.paymentID,
              invoice_no: event.invoice_no,
              payment_status: event.payment_status,
              normal_rate: event.event_fee.normal_rate,
              early_bird_rate: event.event_fee.early_bird_rate,
              latecomer_rate: event.event_fee.latecomer_rate,
              group_discount_rate: event.event_fee.group_discount_rate,
              min_group_discount_pax: event.event_fee.min_group_discount_pax,
              matchingUsers: event.beneficiary.filter((item) =>
                userIDs.includes(item.userID)
              ),
              event_name: event.event_name,
            };
          })
      : [];
    setDataSourceEP(events_data);
  }, [subRowsMP, dataEventInvoice, dataMemberUser]);

  const {
    handleSubmit,
    register,
    formState: { errors },
    control,
    reset,
  } = useForm({
    defaultValues: {
      individual_name: "",
      individual_nric: "",
      individual_dob: "",
      individual_correspondence_address: "",
      individual_registered_address: "",
      individual_office_tel_no: "",
      individual_office_address: "",
      individual_email: "",
      individual_hp_no: "",
      individual_designation: "",
      individual_nature_of_work: "",
      individual_no_of_years_with_present_employer: "",
      e_invoice_pin: ""
    },
  });

  useEffect(() => {
    if (data) {
      reset({
        individual_name: data.individual_name || "",
        individual_nric: data.individual_nric || "",
        individual_dob: data.individual_dob || "",
        individual_correspondence_address:
          data.individual_correspondence_address || "",
        individual_registered_address: data.individual_registered_address || "",
        individual_office_tel_no: data.individual_office_tel_no || "",
        individual_office_address: data.individual_office_address || "",
        individual_email: data.individual_email || "",
        individual_hp_no: data.individual_hp_no || "",
        individual_designation: data.individual_designation || "",
        individual_nature_of_work: data.individual_nature_of_work || "",
        individual_no_of_years_with_present_employer:
          data.individual_no_of_years_with_present_employer || "",
        e_invoice_pin: data.e_invoice_pin || ""
      });
    }
  }, [data, reset]);

  const userID = localStorage.getItem('userID');

  const onSubmit = async (data) => {
    const payload = {
      ID: membership_registrationID,
      membership_status: data.application_status,
      memberID: memberID,
      paymentID: paymentID,
      data: data,
      userID: userID,
    };
    if (Object.keys(errors).length > 0) {
      console.log("Form has errors:", errors);
      return; // Prevent submission if there are errors
    }

    try {
      const response = await IndividualMembershipController.saveRow(payload);
      console.log(response);
      if (response?.status === "success") {
        openNotificationWithIcon(
          "success",
          "Your data has been saved successfully!",
          "Success"
        );
        setShouldRefetchData((prev) => !prev); // Toggle to re-trigger useEffect
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  const onInvalid = (errors) => {
    console.log("Form has errors:", errors);
  };

    const handleGeneratePDF = async (membership_registrationID) => {
      try {
        const payload = new FormData();
        payload.append("membership_registrationID", membership_registrationID);
  
        // console.log(membership_registrationID)
        const data = await IndividualMembershipController.getInfo(
          payload
        );
  
        // console.log(data)
  
        const blob = await pdf(
          <MembershipFormPDF
            data={data}
          />
        ).toBlob();
  
        const url = URL.createObjectURL(blob);
        window.open(url, "_blank");
  
        // Optional: If you want to revoke the URL after opening it
        // setTimeout(() => URL.revokeObjectURL(url), 5000);
      } catch (err) {
        console.error("Error generating PDF:", err);
        alert("Failed to generate pdf.\nPlease try again.");
      }
    };

  // ------------------------------------- DRAGGABLE ROW TABLE ------------------------------------------------------------------------
  const onDragEnd = ({ active, over }) => {
    if (active.id !== over?.id) {
      setDataSourceMP((prevState) => {
        const activeIndex = prevState.findIndex(
          (record) => record.key === active?.id
        );
        const overIndex = prevState.findIndex(
          (record) => record.key === over?.id
        );
        return arrayMove(prevState, activeIndex, overIndex);
      });

      setDataSourceEP((prevState) => {
        const activeIndex = prevState.findIndex(
          (record) => record.key === active?.id
        );
        const overIndex = prevState.findIndex(
          (record) => record.key === over?.id
        );
        return arrayMove(prevState, activeIndex, overIndex);
      });

      setDataSourceMember((prevState) => {
        const activeIndex = prevState.findIndex(
          (record) => record.key === active?.id
        );
        const overIndex = prevState.findIndex(
          (record) => record.key === over?.id
        );
        return arrayMove(prevState, activeIndex, overIndex);
      });
    }
  };

  const RowContext = React.createContext({});
  const DragHandle = () => {
    const { setActivatorNodeRef, listeners } = useContext(RowContext);
    return (
      <Buttons
        type="text"
        size="small"
        icon={<HolderOutlined />}
        style={{
          cursor: "move",
        }}
        ref={setActivatorNodeRef}
        {...listeners}
      />
    );
  };
  const Row = (props) => {
    const {
      attributes,
      listeners,
      setNodeRef,
      setActivatorNodeRef,
      transform,
      transition,
      isDragging,
    } = useSortable({
      id: props["data-row-key"],
    });
    const style = {
      ...props.style,
      transform: CSS.Translate.toString(transform),
      transition,
      ...(isDragging
        ? {
            position: "relative",
            zIndex: 9999,
          }
        : {}),
    };
    const contextValue = useMemo(
      () => ({
        setActivatorNodeRef,
        listeners,
      }),
      [setActivatorNodeRef, listeners]
    );
    return (
      <RowContext.Provider value={contextValue}>
        <tr {...props} ref={setNodeRef} style={style} {...attributes} />
      </RowContext.Provider>
    );
  };
  // ------------------------------------- DRAGGABLE ROW TABLE ------------------------------------------------------------------------

  // --------------------------------- TABLE MEMBERSHIP PAYMENT -------------------------------------------------------------------------------

  const columnsMP = [
    // {
    //   title: "Items", // Title for the expandable icon column
    //   dataIndex: "expand", // Placeholder for the expandable column,
    //   key: "expand",
    //   width: 5,
    // },
    {
      key: "sort",
      align: "center",
      width: 80,
      render: () => <DragHandle />,
    },
    {
      title: "Payment ID",
      dataIndex: "paymentID",
    },
    // {
    //   title: "Invoice No.",
    //   dataIndex: "invoice_no",
    // },
    {
      title: "Status",
      dataIndex: "payment_status",
      render: (payment_status) => {
        if (payment_status === 1) {
          return <Tag color="green">Paid</Tag>;
        } else if (payment_status === 0) {
          return <Tag color="red">Pending</Tag>;
        } else {
          <Tag color="red">Unpaid</Tag>;
        }
      },
    },
  ];

  const expandColumns = [
    {
      title: "Label",
      dataIndex: "label",
      key: "label",
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
    },
    {
      title: "Type",
      key: "type",
      render: (record) => {
        if (record.type === 0) {
          return <Tag color="#2db7f5">Entrance Fee</Tag>;
        } else if (record.type === 1) {
          return <Tag color="#2db7f5">Subscription Fee</Tag>;
        } else if (record.type === 2) {
          return <Tag color="#2db7f5">Renewal Fee</Tag>;
        }
      },
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      render: (amount) => {
        return (
          <>
            <Text>RM</Text>{" "}
            {amount?.toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </>
        );
      },
    },
  ];

  const expandColumnsEP = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Address",
      dataIndex: "address",
      key: "address",
    },
  ];

  const expandedRowRender = (record) => {
    // ---- membership payment data ------------------
    let totalMP = 0; // State for total

    const paymentID = String(record.paymentID);

    const matchingRowMP = subRowsMP.find(
      (item) => String(item.paymentID) === paymentID
    );

    if (matchingRowMP) {
      const expandDataSource = subRowsMP
        .filter((innerItem) => {
          return innerItem.paymentID === paymentID; // Return the comparison result
        })
        .map((item, index) => ({
          key: index,
          label: item.label,
          description: item.description,
          type: item.type,
          amount: item.amount,
        }));

      const calculatedTotal = subRowsMP
        .filter((innerItem) => {
          return innerItem.paymentID === paymentID; // Return the comparison result
        })
        .reduce((acc, item) => acc + Number(item.amount), 0);
      totalMP = calculatedTotal; // Update total with calculated value

      return (
        <>
          <Table
            columns={expandColumns}
            dataSource={expandDataSource}
            pagination={false}
          />

          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <TableContainer sx={{ width: "40%" }} component={Paper}>
              <TableMUI aria-label="spanning table">
                <TableBody>
                  <TableRow>
                    <TableCell>Total Excl.SST</TableCell>
                    <TableCell align="right">
                      RM{" "}
                      {totalMP.toLocaleString("en-US", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>SST 8%</TableCell>
                    <TableCell align="right">RM 0.00</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Total</TableCell>
                    <TableCell align="right">
                      RM{" "}
                      {totalMP.toLocaleString("en-US", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </TableMUI>
            </TableContainer>
          </Box>
        </>
      );
    }
    // ---- membership payment data ------------------

    // ---- event beneficiary data -------------------

    const expandDataSourceEP = record.matchingUsers.map((item, index) => ({
      key: index,
      name: item.name,
      email: item.email,
      address: item.address,
    }));

    return (
      <>
        <Table
          columns={expandColumnsEP}
          dataSource={expandDataSourceEP}
          pagination={false}
        />
      </>
    );

    // ---- event beneficiary data -------------------
  };

  // --------------------------------- TABLE MEMBERSHIP PAYMENT -------------------------------------------------------------------------------

  // --------------------------------- TABLE EVENT PAYMENT -------------------------------------------------------------------------------

  const columnsEP = [
    {
      title: "Beneficiary", // Title for the expandable icon column
      dataIndex: "expand", // Placeholder for the expandable column,
      key: "expand1",
      width: 5,
    },
    {
      key: "sort",
      align: "center",
      width: 80,
      render: () => <DragHandle />,
    },
    {
      title: "Payment ID",
      dataIndex: "paymentID",
    },
    {
      title: "Invoice No.",
      dataIndex: "invoice_no",
    },
    {
      title: "Event Name",
      dataIndex: "event_name",
    },
    {
      title: "Status",
      dataIndex: "payment_status",
      render: (payment_status) => {
        if (payment_status === 1) {
          return <Tag color="green">Paid</Tag>;
        } else if (payment_status === 0) {
          return <Tag color="red">Pending</Tag>;
        } else {
          <Tag color="red">Unpaid</Tag>;
        }
      },
    },
  ];

  // --------------------------------- TABLE EVENT PAYMENT -------------------------------------------------------------------------------

  // --------------------------------- TABLE  MEMBERS -------------------------------------------------------------------------------
  const columnsMember = [
    {
      key: "sort",
      align: "center",
      width: 80,
      render: () => <DragHandle />,
    },
    {
      title: "Name",
      dataIndex: "name",
    },
    {
      title: "NRIC",
      dataIndex: "nric",
    },
    {
      title: "Email",
      dataIndex: "email",
    },
    {
      title: "Address",
      dataIndex: "address",
    },
  ];
  // --------------------------------- TABLE  MEMBERS -------------------------------------------------------------------------------

  return (
    <Box
      sx={{
        display: "flex",
        backgroundColor: "#e8e8e8",
        height: "100%",
        width: "100vw",
      }}
    >
      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        <DrawerHeader />
        {contextHolder}

        <Card variant="outlined">
          <CardContent>
            <Buttons
              type="default"
              color="primary"
              style={{ marginBottom: "10px" }}
              // icon={<WorkspacePremiumIcon />}
              onClick={() => handleGeneratePDF(membership_registrationID)}
            >
              Application Info
            </Buttons>
            <Typography
              gutterBottom
              variant="h6"
              sx={{ color: "text.secondary" }}
            >
              Name
            </Typography>
            <Typography
              variant="h5"
              component="div"
              sx={{ fontWeight: "bold" }}
            >
              {data.individual_name}
            </Typography>
            <Typography variant="h7" sx={{ color: "text.secondary", mb: 1.5 }}>
              Status:{" "}
              {Number(data.status) === 1 ? (
                <Chip label="Active" color="success" />
              ) : (
                <Chip label="Not Active" color="error" />
              )}
            </Typography>
          </CardContent>

          <Grid container spacing={2} sx={{ p: 1 }}>
            <Grid size={6}>
              <Typography variant="h7" sx={{ fontWeight: "bold" }}>
                Member Type:
              </Typography>
              <Typography variant="h7"> {data.member_type_label}</Typography>
            </Grid>
            <Grid size={6}>
              <Typography variant="h7" sx={{ fontWeight: "bold" }}>
                NRIC:
              </Typography>
              <Typography variant="h7"> {data.individual_nric}</Typography>
            </Grid>
          </Grid>

          <Grid container spacing={2} sx={{ p: 1 }}>
            <Grid size={6}>
              <Typography variant="h7" sx={{ fontWeight: "bold" }}>
                Date of Birth:
              </Typography>
              <Typography variant="h7"> {data.individual_dob}</Typography>
            </Grid>
            <Grid size={6}>
              <Typography variant="h7" sx={{ fontWeight: "bold" }}>
                Correspondence Address:
              </Typography>
              <Typography variant="h7">
                {" "}
                {data.individual_correspondence_address}
              </Typography>
            </Grid>
          </Grid>

          <Grid container spacing={2} sx={{ p: 1 }}>
            <Grid size={6}>
              <Typography variant="h7" sx={{ fontWeight: "bold" }}>
                Registered Address:
              </Typography>
              <Typography variant="h7">
                {data.individual_registered_address}
              </Typography>
            </Grid>
            <Grid size={6}>
              <Typography variant="h7" sx={{ fontWeight: "bold" }}>
                Office Tel No.:
              </Typography>
              <Typography variant="h7">
                {" "}
                {data.individual_office_tel_no}
              </Typography>
            </Grid>
          </Grid>

          <Grid container spacing={2} sx={{ p: 1 }}>
            <Grid size={6}>
              <Typography variant="h7" sx={{ fontWeight: "bold" }}>
                Office Address:
              </Typography>
              <Typography variant="h7">
                {data.individual_office_address}
              </Typography>
            </Grid>
            <Grid size={6}>
              <Typography variant="h7" sx={{ fontWeight: "bold" }}>
                Email:
              </Typography>
              <Typography variant="h7"> {data.individual_email}</Typography>
            </Grid>
          </Grid>

          <Grid container spacing={2} sx={{ p: 1 }}>
            <Grid size={6}>
              <Typography variant="h7" sx={{ fontWeight: "bold" }}>
                Qualification:
              </Typography>
              <Typography variant="h7">
                {" "}
                {data.academic_qualification_label}
              </Typography>
            </Grid>
            <Grid size={6}>
              <Typography variant="h7" sx={{ fontWeight: "bold" }}>
                H/P No:
              </Typography>
              <Typography variant="h7"> {data.individual_hp_no}</Typography>
            </Grid>
          </Grid>

          <Grid container spacing={2} sx={{ p: 1 }}>
            <Grid size={6}>
              <Typography variant="h7" sx={{ fontWeight: "bold" }}>
                Designation:
              </Typography>
              <Typography variant="h7">
                {" "}
                {data.individual_designation}
              </Typography>
            </Grid>
            <Grid size={6}>
              <Typography variant="h7" sx={{ fontWeight: "bold" }}>
                Nature of Work:
              </Typography>
              <Typography variant="h7">
                {" "}
                {data.individual_nature_of_work}
              </Typography>
            </Grid>
          </Grid>

          <Grid container spacing={2} sx={{ p: 1 }}>
            <Grid size={6}>
              <Typography variant="h7" sx={{ fontWeight: "bold" }}>
                No. of Years With Present Employer:
              </Typography>
              <Typography variant="h7">
                {" "}
                {data.individual_no_of_years_with_present_employer}
              </Typography>
            </Grid>
            <Grid size={6}>
              <Typography variant="h7" sx={{ fontWeight: "bold" }}>
                Tin No. :
              </Typography>
              <Typography variant="h7">
                {" "}
                {data.e_invoice_pin}
              </Typography>
            </Grid>
          </Grid>

          <CardActions>
            <Button onClick={handleExpandClick} size="small">
              Edit
              <ExpandMore
                expand={expanded}
                aria-expanded={expanded}
                aria-label="show more"
              >
                <ExpandMoreIcon />
              </ExpandMore>
            </Button>
          </CardActions>
        </Card>

        <Collapse in={expanded} timeout="auto" unmountOnExit>
          <CardContent>
            <form
              onSubmit={handleSubmit(onSubmit, onInvalid, {
                shouldFocusError: true,
              })}
            >
              <Grid container spacing={2} sx={{ p: 2 }}>
                <Grid size={4}>
                  <Typography variant="h6">Name</Typography>
                </Grid>
                <Grid size={8}>
                  <TextInput
                    type="text"
                    {...register("individual_name", {
                      required: "This field is required",
                    })}
                    onErrorCheck={errors ? "" : ""}
                    control={control}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={2} sx={{ p: 2 }}>
                <Grid size={4}>
                  <Typography variant="h6">NRIC</Typography>
                </Grid>
                <Grid size={8}>
                  <TextInput
                    type="text"
                    {...register("individual_nric", {
                      required: "This field is required",
                    })}
                    onErrorCheck={errors ? "" : ""}
                    control={control}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={2} sx={{ p: 2 }}>
                <Grid size={4}>
                  <Typography variant="h6">Date of Birth</Typography>
                </Grid>
                <Grid size={8}>
                  <TextInput
                    type="text"
                    {...register("individual_dob", {
                      required: "This field is required",
                    })}
                    onErrorCheck={errors ? "" : ""}
                    control={control}
                  />
                </Grid>
              </Grid>

              <Grid container spacing={2} sx={{ p: 2 }}>
                <Grid size={4}>
                  <Typography variant="h6">Correspondence Address</Typography>
                </Grid>
                <Grid size={8}>
                  <TextInput
                    type="text"
                    {...register("individual_correspondence_address", {
                      required: "This field is required",
                    })}
                    onErrorCheck={errors ? "" : ""}
                    control={control}
                  />
                </Grid>
              </Grid>

              <Grid container spacing={2} sx={{ p: 2 }}>
                <Grid size={4}>
                  <Typography variant="h6">Registered Address</Typography>
                </Grid>
                <Grid size={8}>
                  <TextInput
                    type="text"
                    {...register("individual_registered_address", {
                      required: "This field is required",
                    })}
                    onErrorCheck={errors ? "" : ""}
                    control={control}
                  />
                </Grid>
              </Grid>

              <Grid container spacing={2} sx={{ p: 2 }}>
                <Grid size={4}>
                  <Typography variant="h6">Office Tel No.</Typography>
                </Grid>
                <Grid size={8}>
                  <TextInput
                    type="text"
                    {...register("individual_office_tel_no", {
                      required: "This field is required",
                    })}
                    onErrorCheck={errors ? "" : ""}
                    control={control}
                  />
                </Grid>
              </Grid>

              <Grid container spacing={2} sx={{ p: 2 }}>
                <Grid size={4}>
                  <Typography variant="h6">Office Address</Typography>
                </Grid>
                <Grid size={8}>
                  <TextInput
                    type="text"
                    {...register("individual_office_address", {
                      required: "This field is required",
                    })}
                    onErrorCheck={errors ? "" : ""}
                    control={control}
                  />
                </Grid>
              </Grid>

              <Grid container spacing={2} sx={{ p: 2 }}>
                <Grid size={4}>
                  <Typography variant="h6">Email</Typography>
                </Grid>
                <Grid size={8}>
                  <TextInput
                    type="text"
                    {...register("individual_email", {
                      required: "This field is required",
                    })}
                    onErrorCheck={errors ? "" : ""}
                    control={control}
                  />
                </Grid>
              </Grid>

              <Grid container spacing={2} sx={{ p: 2 }}>
                <Grid size={4}>
                  <Typography variant="h6">H/P No.</Typography>
                </Grid>
                <Grid size={8}>
                  <TextInput
                    type="text"
                    {...register("individual_hp_no", {
                      required: "This field is required",
                    })}
                    onErrorCheck={errors ? errors.company_fax : ""}
                    control={control}
                  />
                </Grid>
              </Grid>

              <Grid container spacing={2} sx={{ p: 2 }}>
                <Grid size={4}>
                  <Typography variant="h6">Designation</Typography>
                </Grid>
                <Grid size={8}>
                  <TextInput
                    type="text"
                    {...register("individual_designation", {
                      required: "This field is required",
                    })}
                    onErrorCheck={errors ? "" : ""}
                    control={control}
                  />
                </Grid>
              </Grid>

              <Grid container spacing={2} sx={{ p: 2 }}>
                <Grid size={4}>
                  <Typography variant="h6">Nature of Work</Typography>
                </Grid>
                <Grid size={8}>
                  <TextInput
                    type="text"
                    {...register("individual_nature_of_work", {
                      required: "This field is required",
                    })}
                    onErrorCheck={errors ? "" : ""}
                    control={control}
                  />
                </Grid>
              </Grid>

              <Grid container spacing={2} sx={{ p: 2 }}>
                <Grid size={4}>
                  <Typography variant="h6">
                    No. of Years With Present Employer
                  </Typography>
                </Grid>
                <Grid size={8}>
                  <TextInput
                    type="text"
                    {...register(
                      "individual_no_of_years_with_present_employer",
                      {
                        required: "This field is required",
                      }
                    )}
                    onErrorCheck={
                      errors
                        ? errors.individual_no_of_years_with_present_employer
                        : ""
                    }
                    control={control}
                  />
                </Grid>
              </Grid>

              <Grid container spacing={2} sx={{ p: 2 }}>
                <Grid size={4}>
                  <Typography variant="h6">
                    Tin No.
                  </Typography>
                </Grid>
                <Grid size={8}>
                  <TextInput
                    type="text"
                    {...register(
                      "e_invoice_pin",
                    )}
                    onErrorCheck={
                      errors
                        ? errors.e_invoice_pin
                        : ""
                    }
                    control={control}
                  />
                </Grid>
              </Grid>

              <Button
                sx={{
                  backgroundColor: "#d33333",
                }}
                variant="contained"
                type="submit"
              >
                <Typography variant="h6">Save</Typography>
              </Button>
            </form>
          </CardContent>
        </Collapse>

        <Card variant="outlined" sx={{ mt: 6, mb: 6 }}>
          <CardContent>
            <Box sx={{ width: "100%" }}>
              <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <Tabs
                  value={value}
                  onChange={handleChange}
                  aria-label="basic tabs example"
                >
                  <Tab label="Member Records" {...a11yProps(0)} />

                  <Tab label="Payment Records" {...a11yProps(1)} />
                  {/* <Tab label="Invoice Records" {...a11yProps(1)} /> */}
                  <Tab label="Event Records" {...a11yProps(2)} />
                </Tabs>
              </Box>
              <CustomTabPanel value={value} index={0}>
                <DndContext
                  modifiers={[restrictToVerticalAxis]}
                  onDragEnd={onDragEnd}
                >
                  <SortableContext
                    items={dataSourceMP.map((i) => i.key)}
                    strategy={verticalListSortingStrategy}
                  >
                    <Table
                      rowKey="key"
                      components={{
                        body: {
                          row: Row,
                        },
                      }}
                      columns={columnsMember}
                      dataSource={dataSourceMember}
                    />
                  </SortableContext>
                </DndContext>
              </CustomTabPanel>
              <CustomTabPanel value={value} index={1}>
                <DndContext
                  modifiers={[restrictToVerticalAxis]}
                  onDragEnd={onDragEnd}
                >
                  <SortableContext
                    items={dataSourceMP.map((i) => i.key)}
                    strategy={verticalListSortingStrategy}
                  >
                    <Table
                      rowKey="key"
                      components={{
                        body: {
                          row: Row,
                        },
                      }}
                      expandable={{
                        expandedRowRender,
                        defaultExpandedRowKeys: ["1"],
                      }}
                      columns={columnsMP}
                      dataSource={dataSourceMP}
                    />
                  </SortableContext>
                </DndContext>
              </CustomTabPanel>

              <CustomTabPanel value={value} index={2}>
                <DndContext
                  modifiers={[restrictToVerticalAxis]}
                  onDragEnd={onDragEnd}
                >
                  <SortableContext
                    items={dataSourceEP.map((i) => i.key)}
                    strategy={verticalListSortingStrategy}
                  >
                    <Table
                      rowKey="key"
                      components={{
                        body: {
                          row: Row,
                        },
                      }}
                      expandable={{
                        expandedRowRender,
                        defaultExpandedRowKeys: ["1"],
                      }}
                      columns={columnsEP}
                      dataSource={dataSourceEP}
                    />
                  </SortableContext>
                </DndContext>
              </CustomTabPanel>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
};

export default Dashboard;
